import { useRef, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import C from "classnames";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

import S from "./AssessmentCard.module.scss";

export const AssessmentCard = ({
  title,
  description,
  isLocked,
  estimatedTime,
  type,
  status,
  dueDate,
  points,
  assignmentUUID,
}) => {
  const { navigateTo } = useSmartNavigation();
  const descriptionRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const element = descriptionRef.current;
    if (element) {
      setIsClamped(element.scrollHeight > element.clientHeight);
    }
  }, [description]);

  const startAssessmentText = isLocked
    ? "Assessment Locked"
    : status === "InProgress"
      ? "Continue Assessment"
      : "Start Assessment";

  const navigateToAssessment = () => {
    navigateTo(buildRoute("Ka.routes.assignment.route", { assignmentId: assignmentUUID }));
  };

  const formatDate = dateString => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch (_error) {
      return dateString;
    }
  };

  return (
    <div className={C(S.assessmentCard, { [S.isLocked]: isLocked })} onClick={navigateToAssessment}>
      <svg className={S.completionBadge} width="90" height="101" viewBox="0 0 90 101" fill="none">
        <circle cx="61" cy="40" r="60.1286" stroke="#9EA0A2" strokeWidth="1.74286" />
        <circle cx="60.9996" cy="39.9994" r="49.9297" stroke="#9EA0A2" strokeWidth="1.74286" />
        <path
          d="M38.4851 44.0536L49.7456 59.5895L83.5197 20.4121"
          stroke="#9EA0A2"
          strokeWidth="1.74286"
        />
      </svg>
      <div className={S.assessmentCardHeader}>
        <Tag value={type} severity="warning" rounded={true} />
        {points > 0 && <h5 className={C(S.mutedText, "atlas-h5")}> +{points}</h5>}
      </div>
      <div className={S.assessmentCardBody}>
        <h4 className="atlas-h4">{title}</h4>
        <p
          ref={descriptionRef}
          className={C("body-md", S.clampedText)}
          data-pr-tooltip={isClamped ? description : null}
          data-pr-position="bottom"
          data-pr-classname={S.descriptionTooltip}
        >
          {description}
        </p>
        {isClamped && <Tooltip target={descriptionRef} style={{ maxWidth: "400px" }} />}
      </div>
      <div className={S.assessmentDetailsWrapper}>
        <div>
          <p className={C(S.mutedText, "body-sm")}>Due Date</p>
          <p className="body-md">{formatDate(dueDate)}</p>
        </div>
        <div>
          <p className={C(S.mutedText, "body-sm")}>Estimated Time</p>
          <p className="body-md">~ {estimatedTime} mins</p>
        </div>
      </div>
      <div className={S.assessmentCardFooter}>
        <Button
          label={startAssessmentText}
          disabled={isLocked}
          onClick={e => {
            e.stopPropagation();
            navigateToAssessment();
          }}
        />
      </div>
    </div>
  );
};
